/* eslint-disable react/prop-types */
import React from "react";
import { useSnackbar } from "notistack";
import { Button } from "@material-ui/core";

export default ({ action, onAction, key, noDismiss = false, onDismiss }) => {
  const { closeSnackbar } = useSnackbar();
  return action ? (
    <>
      {!noDismiss && (
        <Button
          onClick={() => {
            closeSnackbar(key);
            if (onDismiss) onDismiss();
          }}
        >
          Dismiss
        </Button>
      )}
      <Button
        onClick={() => {
          closeSnackbar(key);
          if (onAction) onAction();
        }}
      >
        {action}
      </Button>
    </>
  ) : null;
};
